export default __webpack_public_path__ + "static/media/work1image1.a2b0a0e7.jpeg";